import { capitalize } from '@shared/Frontend/utils/capitalize'
import * as i18next from 'i18next'
import { List } from 'immutable'
import * as React from 'react'
import {
  AsyncState,
  IOWidget,
  Link as LinkComponent,
  Updater,
  async,
  fromJSX,
  loadingAsyncState,
  wait
} from 'widgets-for-react'
import { PublicSiteState } from '../../../../../../../root/state'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'
import { link } from '../../../../cms/blocks/utils.gen'
import { getAllUpdates, getOverview } from '../../../../drupal/api/api.mod'
import { parseImageUrl } from '../../../../drupal/rendering/image_utils.mod'
import { PaginatedItem } from '../../../../drupal/types_and_parser/extra_types.mod'
import {
  ParsedImageFileWithTargetItem,
  ParsedNodeExpertise,
  ParsedNodeUpdate
} from '../../../../drupal/types_and_parser/types.ext.gen'
import { getDrupalLanguage } from '../../../application.mod'
import { AbstractParsedUpdate } from '../../../custom_pages/shared/AbstractParsedUpdate'
import { loader } from '../../../templates/loader.mod'
import { getLangFromUrl } from '../../../utils/history.mod'
import { updateBlockData } from '../types.mod'
import moment = require('moment')

export type updateBlockProps = {
  block_index: number
  title: string
  link: Link
  allUpdates: AsyncState<PaginatedItem<AbstractParsedUpdate>>
  updateNodes: AsyncState<PaginatedItem<ParsedNodeUpdate>>
  expertiseNodes: AsyncState<PaginatedItem<ParsedNodeExpertise>>
}

export type node = {
  title: string
  image?: ParsedImageFileWithTargetItem
  link?: Link
  publishDate: string
}

export type updateBlockStyle = {}

export function updateBlock(
  props: updateBlockProps,
  options?: { style?: updateBlockStyle; key?: string }
): IOWidget<PublicSiteState, Updater<CMSState>> {
  return (public_state: PublicSiteState) =>
    fromJSX((setState) => {
      let current_page_id = -1
      let current_title = ''
      if (public_state.page.page.kind == 'loaded') {
        current_page_id = public_state.page.page.value.extra_data.node.id
        current_title = public_state.page.page.value.extra_data.node.label
      }
      return (
        <section className="block block--related block--updates ls-block-spacing">
          <div className="block__inner ls-container">
            {props.updateNodes.kind == 'unloaded' && props.expertiseNodes.kind == 'unloaded'
              ? wait(1.5)(() => {})
                  .map(() => {
                    setState((s) => {
                      return {
                        ...s,
                        blocks: s.blocks
                          .map((item, key) => {
                            if (
                              key == props.block_index &&
                              item.kind == 'updateBlock' &&
                              public_state.page.page.kind == 'loaded' &&
                              public_state.page.page.value.extra_data.node.bundle == 'update'
                            ) {
                              let item1: updateBlockData

                              if (item.value[0].updateNodes.kind == 'unloaded') {
                                let labels = public_state.page.page.value.extra_data.node.field_category.map((elem) => elem.id).toArray()
                                item.value[0].updateNodes = loadingAsyncState(() =>
                                  getOverview<ParsedNodeUpdate>(
                                    'related-content-update',
                                    getLangFromUrl(),
                                    null,
                                    List(labels),
                                    true
                                  )
                                )
                              }
                              if (item.value[0].expertiseNodes.kind == 'unloaded') {
                                let labels = public_state.page.page.value.extra_data.node.field_category.map((elem) => elem.id).toArray()
                                item.value[0].expertiseNodes = loadingAsyncState(() =>
                                  getOverview<ParsedNodeExpertise>(
                                    'related-content-expertise',
                                    getLangFromUrl(),
                                    null,
                                    List(labels),
                                    true
                                  )
                                )
                              } else {
                                return item
                              }

                              item1 = { ...item }
                              return item1
                            } else if (
                              key == props.block_index &&
                              item.kind == 'updateBlock' &&
                              public_state.page.page.kind == 'loaded' &&
                              (public_state.page.page.value.extra_data.node.bundle == 'expertise' ||
                                public_state.page.page.value.extra_data.node.bundle == 'homepage')
                            ) {
                              let item1: updateBlockData

                              if (item.value[0].updateNodes.kind == 'unloaded') {
                                let labels =
                                  public_state.page.page.value.extra_data.node.bundle == 'expertise'
                                    ? public_state.page.page.value.extra_data.node.field_category.map((elem) => elem.id).toArray()
                                    : []
                                item.value[0].updateNodes = loadingAsyncState(() =>
                                  getOverview<ParsedNodeUpdate>(
                                    'related-content-update',
                                    getLangFromUrl(),
                                    null,
                                    List(labels),
                                    true
                                  )
                                )
                                let item1 = { ...item }
                                return item1
                              }
                              return item
                            } else if (
                              key == props.block_index &&
                              item.kind == 'updateBlock' &&
                              public_state.page.page.kind == 'loaded'
                            ) {
                              if (item.value[0].allUpdates.kind == 'unloaded') {
                                // item.value[0].updateNodes = loadingAsyncState(() =>
                                //   Api.GetOverview<ParsedNodeUpdate>('update-overview', getLangFromUrl())
                                // )
                                item.value[0].allUpdates = loadingAsyncState(() => getAllUpdates(getLangFromUrl()))
                                let item1 = { ...item }
                                return item1
                              }
                              return item
                            } else {
                              return item
                            }
                          })
                          .toMap()
                      }
                    })
                  })
                  .run(() => {})
              : null}

            <header className="block__header">
              {props.title == undefined ? (
                <h2 className="block__title title--l">{i18next.t('Update:Body:Title')}</h2>
              ) : (
                <h2 className="block__title title--l">{props.title}</h2>
              )}
            </header>

            {public_state.page.page.kind == 'loaded' && public_state.page.page.value.extra_data.node.bundle == 'update' ? (
              <div className="block__content">
                {async(props.updateNodes).run((a) => {
                  setState((s0) => {
                    let block = s0.blocks.get(props.block_index)
                    block.value[0].updateNodes = a(block.value[0].updateNodes)
                    return { ...s0, blocks: s0.blocks.set(props.block_index, block) }
                  })
                })}
                {async(props.expertiseNodes).run((a) => {
                  setState((s0) => {
                    let block = s0.blocks.get(props.block_index)
                    block.value[0].expertiseNodes = a(block.value[0].expertiseNodes)
                    return { ...s0, blocks: s0.blocks.set(props.block_index, block) }
                  })
                })}

                {props.expertiseNodes.kind == 'loaded' && props.updateNodes.kind == 'loaded'
                  ? nodesSplitter(props.updateNodes.value.items, props.expertiseNodes.value.items, current_page_id)
                  : props.updateNodes.kind != 'loaded'
                  ? loader.run((_) => {})
                  : loader.run((_) => {})}
                {props.link == undefined ? (
                  <></>
                ) : (
                  <footer className="block__footer">{link(props.link, { classname: 'link' }, props.link.title)}</footer>
                )}
              </div>
            ) : (
              <div className="block__content">
                {async(props.updateNodes).run((a) => {
                  setState((s0) => {
                    let block = s0.blocks.get(props.block_index)
                    block.value[0].updateNodes = a(block.value[0].updateNodes)
                    return { ...s0, blocks: s0.blocks.set(props.block_index, block) }
                  })
                })}
                {async(props.allUpdates).run((a) => {
                  setState((s0) => {
                    let block = s0.blocks.get(props.block_index)
                    block.value[0].allUpdates = a(block.value[0].allUpdates)
                    return { ...s0, blocks: s0.blocks.set(props.block_index, block) }
                  })
                })}

                {props.allUpdates.kind == 'loaded'
                  ? updatenodesSplitter(props.allUpdates.value.items, current_title)
                  : props.updateNodes.kind == 'loaded'
                  ? nodesSplitter(props.updateNodes.value.items, [], current_page_id)
                  : loader.run((_) => {})}
                {props.link == undefined ? (
                  <></>
                ) : (
                  <footer className="block__footer">{link(props.link, { classname: 'link' }, props.link.title)}</footer>
                )}
              </div>
            )}
          </div>
        </section>
      )
    })
}

const nodesSplitter = (
  updatepageArray: Array<ParsedNodeUpdate>,
  expertisepageArray: Array<ParsedNodeExpertise>,
  currentId: number
) => {
  const updateArray = updatepageArray.filter((node) => node.id != currentId)
  const expertiseArray = expertisepageArray.filter((node) => node.id != currentId)

  const maxNodes = 4
  const firstBlock = updateArray.slice(0, 1).map((node, index) => {
    return nodeItem(node, getLangFromUrl(), 'First', 'firstUpdateBlock' + index)
  })
  let expertiseSliceEnd, updateSliceEnd
  expertiseSliceEnd = expertiseArray.length > 0 ? expertiseArray.length % maxNodes : 0
  updateSliceEnd = maxNodes - expertiseSliceEnd

  let otherBlock = expertiseArray
    .slice(0, expertiseSliceEnd)
    .map((node, index) => {
      return nodeItem(node, getLangFromUrl(), 'Other', 'ExpertiseBlock_' + index)
    })
    .concat(
      updateArray.slice(1, updateSliceEnd).map((node, index) => {
        return nodeItem(node, getLangFromUrl(), 'Other', 'UpdateBlock_' + index)
      })
    )
  return (
    <ul className="block__list grid">
      {firstBlock}
      {otherBlock}
    </ul>
  )
}

const updatenodesSplitter = (updatepageArray: Array<AbstractParsedUpdate>, currentTitle: string) => {
  const updateArray = updatepageArray.filter((node) => node.title != currentTitle)

  const maxNodes = 4
  const firstBlock = updateArray.slice(0, 1).map((node, index) => {
    return updateNodeItem(node, 'First', 'firstUpdateBlock' + index)
  })
  const otherBlock = updateArray.slice(1, maxNodes).map((node, index) => {
    return updateNodeItem(node, 'Other', 'firstUpdateBlock' + index)
  })

  return (
    <ul className="block__list grid">
      {firstBlock}
      {otherBlock}
    </ul>
  )
}

export type PageTeaser = {
  title: string
  field_introduction_image: string
  field_introduction: string
  field_category?: string
  creation_date: string
  view_node: string
}

export const nodeItem = (
  update_item: PageTeaser | ParsedNodeUpdate | ParsedNodeExpertise,
  lang: string,
  styleId: 'First' | 'Other',
  key = 'nodeItem'
) => {
  const isPageTeaser = (entity): entity is PageTeaser => (entity as PageTeaser).view_node !== undefined

  const link = isPageTeaser(update_item)
    ? update_item.view_node
    : update_item.language_links.get(getDrupalLanguage(getLangFromUrl()))
  const title = isPageTeaser(update_item) ? update_item.title : update_item.label
  const categories = (update_item as ParsedNodeUpdate).field_category.map((x) => x.label).toArray()
  let image = ''
  let alt = ''
  const creationDate: moment.Moment = isPageTeaser(update_item)
    ? moment(update_item.creation_date).locale('nl')
    : update_item.created
  if (isPageTeaser(update_item)) {
    image = parseImageUrl(update_item.field_introduction_image)
  } else if (!isPageTeaser(update_item)) {
    if (update_item.field_introduction_image && update_item.field_introduction_image.thumbnail.image) {
      image =
        styleId == 'First'
          ? parseImageUrl(update_item.field_introduction_image.thumbnail.image.style_urls['2880w'])
          : parseImageUrl(update_item.field_introduction_image.thumbnail.image.style_urls.grid)
      alt = update_item.field_introduction_image.thumbnail.alt
    }
  }

  return (
    <li key={key} className="grid__item">
      <article className="grid__article">
        {styleId == 'First' ? (
          <LinkComponent to={link}>
            <div className="grid__content">
              <header className="grid__header">
                <h3 className="grid__title title--m">{title}</h3>
                {(isPageTeaser(update_item) || update_item.bundle == 'update') && (
                  <time className="grid__date text--s" dateTime={creationDate.format()}>
                    {creationDate.format('D MMMM YYYY')}
                  </time>
                )}
                <br />
                <span className="grid__link link">{i18next.t('Common:ReadMore')}</span>
              </header>
            </div>
            <div className="grid__wrap">
              <div className="grid__visual fit-object">
                <img loading="lazy" className="grid__image" src={image} alt={alt} />
              </div>
            </div>
          </LinkComponent>
        ) : (
          <LinkComponent to={link} className="grid__link">
            <div className="grid__wrap">
              <div className="grid__tags tags">
                {categories.map((category, index) => {
                  return (
                    <span key={category} id={'tagd' + index} className="grid__tag tag tag--m">
                      {category}
                    </span>
                  )
                })}
                <span className="grid__tag tag tag--m">{capitalize((update_item as any)?.bundle)}</span>
              </div>
              <div className="grid__visual fit-object">
                <img loading="lazy" className="grid__image" src={image} alt={alt} />
              </div>
            </div>
            <div className="grid__content">
              <header className="grid__header">
                <h3 className="grid__title title--s">{title}</h3>
              </header>
              {(isPageTeaser(update_item) || update_item.bundle == 'update') && (
                <time className="grid__date text--s" dateTime={creationDate.format()}>
                  {creationDate.format('D MMMM YYYY')}
                </time>
              )}
            </div>
          </LinkComponent>
        )}
      </article>
    </li>
  )
}

export const updateNodeItem = (update_item: AbstractParsedUpdate, styleId: 'First' | 'Other', key = 'nodeItem') => {
  const link = update_item?.view_node

  const title = update_item?.title
  const categories = update_item?.field_category.split(',')
  let image = update_item?.field_media_image
  let alt = 'alt'
  const creationDate = update_item.created

  return (
    <li key={key} className="grid__item">
      <article className="grid__article">
        {styleId == 'First' ? (
          <LinkComponent to={link}>
            <div className="grid__content">
              <header className="grid__header">
                <h3 className="grid__title title--m">{title}</h3>
                <span className="grid__link link">{i18next.t('Common:ReadMore')}</span>
              </header>
            </div>
            <div className="grid__wrap">
              <div className="grid__visual fit-object">
                <img loading="lazy" className="grid__image" src={image} alt={alt} />
              </div>
            </div>
          </LinkComponent>
        ) : (
          <LinkComponent to={link} className="grid__link">
            <div className="grid__wrap">
              <div className="grid__tags tags">
                {categories.map((category, index) => {
                  return (
                    <span key={category} id={'tagd' + index} className="grid__tag tag tag--m">
                      {category}
                    </span>
                  )
                })}
              </div>
              <div className="grid__visual fit-object">
                <img loading="lazy" className="grid__image" src={image} alt={alt} />
              </div>
            </div>
            <div className="grid__content">
              <header className="grid__header">
                <h3 className="grid__title">{title}</h3>
              </header>
              <time className="grid__date text--s" dateTime={creationDate}>
                {creationDate}
              </time>
            </div>
          </LinkComponent>
        )}
      </article>
    </li>
  )
}
